import React, { useContext } from 'react';
import { Summary as OrderSummary } from '|/app/services';
import * as Summary from '|/app/steps/order-summary/order-summary-components.styles';
import {
  Wrapper,
  Heading,
  SubHeading,
  StyledCloseLarge,
  OrderSummaryWrapper
} from '|/app/steps/order-summary/order-summary.styles';
import * as Section from '|/app/steps/order-summary/sections';
import SummaryContext from '|/app/summary-context';
import useExperimentBucket from '|/helpers/use-experiment-bucket';

const defaultProps = {
  orderSummary: null as null | OrderSummary
};

export const SummaryComponent = ({ orderSummary } = defaultProps) => {
  const { vehicle: { inventoryType = null } = {} } = orderSummary || {};
  const { showSummary, setShowSummary } = useContext(SummaryContext);

  const cardsExperimentBucket = useExperimentBucket('pmt-cards-mvp', [
    'card-payment-method',
    'control'
  ]);

  if (orderSummary === null || !showSummary) return null;
  const isMarketplaceVehicle = inventoryType === 'DealerMarketplace';

  return (
    <Wrapper>
      <StyledCloseLarge
        onClick={() => {
          setShowSummary(false);
        }}
        data-analytics-id="pp_order_summary_close"
      />
      <Heading>
        My Purchase Summary
        <SubHeading>
          Please carefully review and confirm your order details below. Make all
          the necessary changes to your selections.
        </SubHeading>
      </Heading>
      <OrderSummaryWrapper>
        <Summary.Wrapper className="order-summary-wrapper">
          <Summary.Column>
            <Section.DeliveryDetails summary={orderSummary} />
            <Section.AccountDetails summary={orderSummary} />
            <Section.CoBuyerDetails summary={orderSummary} />
          </Summary.Column>
          <Summary.Column>
            <Section.CostBreakdown summary={orderSummary} />
            {cardsExperimentBucket === 'control' && (
              <Section.PaymentControl summary={orderSummary} />
            )}
            {cardsExperimentBucket === 'card-payment-method' && (
              <Section.PaymentCards summary={orderSummary} />
            )}
          </Summary.Column>
        </Summary.Wrapper>
        {isMarketplaceVehicle && (
          <Summary.MarketplaceReminderWrapper>
            <Summary.MarketplaceReminderHeading>
              <span className="hide-sm">Reminder:&nbsp;</span>This is a Carvana
              Marketplace Vehicle
            </Summary.MarketplaceReminderHeading>
            <Summary.MarketplaceReminderText>
              This vehicle comes with all the same great benefits as all our
              vehicles. This vehicle is in our partner&apos;s possession.
              Continue with your purchase as normal, and we will confirm this
              vehicle&apos;s availability for you once we&apos;ve verified your
              order. If the vehicle becomes unavailable, we will let you know.
            </Summary.MarketplaceReminderText>
          </Summary.MarketplaceReminderWrapper>
        )}
      </OrderSummaryWrapper>
      <Summary.ButtonWrapper>
        <Summary.ContinueButton
          hierarchyType="primary"
          color="blue"
          icon="none"
          size="large"
          isPrimaryCta={true}
          onClick={() => setShowSummary(false)}
          text="Continue"
          data-analytics-id="pp_order_summary_continue"
        />
      </Summary.ButtonWrapper>
    </Wrapper>
  );
};

export default SummaryComponent;
